import { useEffect, useState } from "react";
import {
  fetchZonesPOReports,
  fetchZonePartiesPOReports
} from "Service/ApiService";

/* ------------------ HARDCODED SCHEMES ------------------ */
const schemeOptions = [
  { label: "SCHEME MAY", value: "scheme_may" },
  { label: "SCHEME JUNE", value: "scheme_june" }
];


const SchemeReportController = () => {
  const user = JSON.parse(localStorage.getItem("user"));

  /* ------------------ STATE ------------------ */
  const [zoneOptions, setZoneOptions] = useState([]);
  const [customerNameOptions, setCustomerNameOptions] = useState([]);
   //const [loadingMain, setLoadingMain] = useState(false);
  

const [filters, setFilters] = useState({
  scheme: null,
  zone: [],
  customerName: []
});


  const [schemeData, setSchemeData] = useState([]);

  /* ------------------ LOAD ZONES ------------------ */
 /* ------------------ ZONES ------------------ */
  useEffect(() => {
    const loadZones = async () => {
      try {
     //   setLoadingZones(true);

        const res = await fetchZonesPOReports(user.userCode, "outstanding");
        if (res?.status && Array.isArray(res.zones)) {
          setZoneOptions(
            res.zones.map((z, idx) => ({
              label: z.region?.trim() || "(NO REGION)",
              value: `${z.zoneCode}_${idx}`,   // ✅ UNIQUE
              zoneCode: z.zoneCode,             // real value
              amount: z.amount
            }))
          );
        }
      } catch (err) {
        console.error("Zone fetch error:", err);
      }
    };
    loadZones();
  }, [user.userCode]);

 // Customers / Parties
  useEffect(() => {
    const loadParties = async () => {
      try {
        //setLoadingCustomers(true);
        const res = await fetchZonePartiesPOReports(user.userCode, {
          type: "outstanding"
        });
        // console.error("res.parties", res.parties);
        if (res?.status && Array.isArray(res.parties)) {
          setCustomerNameOptions(
            res.parties.map((p) => ({
              label: `${p.partyCode} - ${p.partyName.trim()}`,
              value: p.partyCode,
              amount: p.amount
            }))
          );
        } else {
          setCustomerNameOptions([]);
        }
      } catch (err) {
        console.error("Party fetch error:", err);
        setCustomerNameOptions([]);
      }
    };

    loadParties();
  }, [user.userCode]);

  /* ------------------ CUSTOMERS ------------------ */
  const handleCustomerSearch = async (inputValue) => {
    if (inputValue.length < 3) return;

    try {
      //setLoadingCustomers(true);

      const res = await fetchZonePartiesPOReports(user.userCode, {
        search: inputValue,
        type: "outstanding"
      });
      if (res?.status && Array.isArray(res.parties)) {
        setCustomerNameOptions(
          res.parties.map((p) => ({
            label: `${p.partyCode} - ${p.partyName.trim()}`,
            value: p.partyCode,
            amount: p.amount
          }))
        );
      }
    } catch (err) {
      console.error("Customer search error:", err);
    } 
  };
  /* ------------------ DUMMY TABLE DATA ------------------ */
 useEffect(() => {
  setSchemeData([
    {
      scmname: "SCHEME MAY",
      zone_cd: "Z01",
      zone: "NORTH",
      cust_group: "RETAIL",
      customer_code: "100001",
      customer_name: "ABC TRADERS",
      benefit_desc: "5% DISCOUNT",
      division: "MISTAIR",
      mst_mg: "MG01",
      bill_no: "BILL-4587"
    },
    {
      scmname: "SCHEME JUNE",
      zone_cd: "Z02",
      zone: "SOUTH",
      cust_group: "WHOLESALE",
      customer_code: "100002",
      customer_name: "XYZ ENTERPRISE",
      benefit_desc: "FREE SCHEME",
      division: "MISTAIR",
      mst_mg: "MG02",
      bill_no: "BILL-4590"
    },
     {
      scmname: "SCHEME MAY",
      zone_cd: "Z01",
      zone: "NORTH",
      cust_group: "RETAIL",
      customer_code: "100001",
      customer_name: "ABC TRADERS",
      benefit_desc: "5% DISCOUNT",
      division: "MISTAIR",
      mst_mg: "MG01",
      bill_no: "BILL-4587"
    },
    {
      scmname: "SCHEME JUNE",
      zone_cd: "Z02",
      zone: "SOUTH",
      cust_group: "WHOLESALE",
      customer_code: "100002",
      customer_name: "XYZ ENTERPRISE",
      benefit_desc: "FREE SCHEME",
      division: "MISTAIR",
      mst_mg: "MG02",
      bill_no: "BILL-4590"
    }, {
      scmname: "SCHEME MAY",
      zone_cd: "Z01",
      zone: "NORTH",
      cust_group: "RETAIL",
      customer_code: "100001",
      customer_name: "ABC TRADERS",
      benefit_desc: "5% DISCOUNT",
      division: "MISTAIR",
      mst_mg: "MG01",
      bill_no: "BILL-4587"
    },
    {
      scmname: "SCHEME JUNE",
      zone_cd: "Z02",
      zone: "SOUTH",
      cust_group: "WHOLESALE",
      customer_code: "100002",
      customer_name: "XYZ ENTERPRISE",
      benefit_desc: "FREE SCHEME",
      division: "MISTAIR",
      mst_mg: "MG02",
      bill_no: "BILL-4590"
    },
     {
      scmname: "SCHEME MAY",
      zone_cd: "Z01",
      zone: "NORTH",
      cust_group: "RETAIL",
      customer_code: "100001",
      customer_name: "ABC TRADERS",
      benefit_desc: "5% DISCOUNT",
      division: "MISTAIR",
      mst_mg: "MG01",
      bill_no: "BILL-4587"
    },
    {
      scmname: "SCHEME JUNE",
      zone_cd: "Z02",
      zone: "SOUTH",
      cust_group: "WHOLESALE",
      customer_code: "100002",
      customer_name: "XYZ ENTERPRISE",
      benefit_desc: "FREE SCHEME",
      division: "MISTAIR",
      mst_mg: "MG02",
      bill_no: "BILL-4590"
    }
  ]);
}, []);


 return {
  schemeOptions,
  zoneOptions,
  customerNameOptions,
  filters,
  setFilters,
  schemeData,
  handleCustomerSearch
};

};

export default SchemeReportController;
